import { render } from "./OToggleOption.vue?vue&type=template&id=ddf01b26&scoped=true"
import script from "./OToggleOption.vue?vue&type=script&lang=js"
export * from "./OToggleOption.vue?vue&type=script&lang=js"

import "./OToggleOption.vue?vue&type=style&index=0&id=ddf01b26&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf01b26"]])

export default __exports__